import { ref } from 'vue';
import { acceptHMRUpdate, defineStore } from 'pinia';
export const useConsumptionStore = defineStore('consumption', () => {
    // 当前桌台切换的类型
    const consumptionType = ref('index');
    // 当前支付方式
    const payConsumptionType = ref('');
    // 设置当前支付
    const setPayConsumptionType = (type) => {
        payConsumptionType.value = type;
    };
    // 设置当前切换的类型
    const setConsumptionType = (type) => {
        consumptionType.value = type;
        setPayConsumptionType('');
    };

    return {
        consumptionType,
        setConsumptionType,
        payConsumptionType,
        setPayConsumptionType
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useConsumptionStore, import.meta.hot));
}
